import { render, staticRenderFns } from "./auth-layout.vue?vue&type=template&id=c664d044&scoped=true&"
import script from "./auth-layout.vue?vue&type=script&lang=ts&"
export * from "./auth-layout.vue?vue&type=script&lang=ts&"
import style0 from "./auth-layout.vue?vue&type=style&index=0&id=c664d044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c664d044",
  null
  
)

export default component.exports